import { pxToRem } from 'modules/spacing';
import { calculateLineHeight } from '../utils/calculateLineHeight';
export const size = {
    tiny: pxToRem(11),
    small: pxToRem(13),
    base: pxToRem(15),
    infrequent: pxToRem(20),
    medium: pxToRem(24),
    large: pxToRem(28),
    xLarge: pxToRem(40),
};
export const fontSize = (sizeOrName, lineHeight = 'auto') => {
    const value = (size === null || size === void 0 ? void 0 : size[sizeOrName]) || sizeOrName;
    return `
    font-size: ${value};
    line-height: ${lineHeight === 'auto' ? calculateLineHeight(value) : lineHeight};
  `;
};
